import { ChangeDetectionStrategy, Component, Inject, OnInit } from "@angular/core";
import { isNil } from "lodash";
import {
  DynamicDialogConfig as OldDynamicDialogConfig,
  DynamicDialogRef as OldDynamicDialogRef,
} from "primeng-v17/dynamicdialog";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { environment } from "../../../../environments/environment";
import { SettingsService } from "../../../shared/services/settings.service";
import { SelectedCandidateForEdit } from "../candidate-edit/candidate-edit.model";
import { NewUiCandidateEditComponent } from "../candidate-edit/new-ui-candidate-edit.component";

@Component({
  selector: "new-ui-candidate-flexible-edit",
  templateUrl: "./new-ui-candidate-flexible-edit.component.html",
  imports: [NewUiCandidateEditComponent],
  host: { class: "h-full" },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewUiCandidateFlexibleEditComponent implements OnInit {
  candidateId: string;
  candidateOrganizationId: string;

  selectedCandidate: SelectedCandidateForEdit;

  constructor(
    private readonly settings: SettingsService,
    @Inject(environment.newUI ? DynamicDialogConfig : OldDynamicDialogConfig)
    private readonly config: OldDynamicDialogConfig | DynamicDialogConfig,
    @Inject(environment.newUI ? DynamicDialogRef : OldDynamicDialogRef)
    private readonly dialog: OldDynamicDialogRef | DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.selectedCandidate = this.getSelectedCandidate(
      this.config.data.candidateId,
      this.config.data.candidateOrganizationId
    );
  }

  protected close(): void {
    this.dialog.close();
  }

  private getSelectedCandidate(candidateId: string, candidateOrganizationId: string): SelectedCandidateForEdit {
    if (isNil(candidateId) || isNil(candidateOrganizationId)) return null;

    return {
      id: candidateId,
      organizationId: candidateOrganizationId,
      immigrationCountry: this.settings.standardImmigrationCountry,
    };
  }
}
